
export class HotelMap {
    private name: string;
    private region: string;
    private address: string;
    private geometry: any = {
        lat: 999,
        lng: 999,
    };

    constructor() {
        window.addEventListener("load", () => {
            this.readData();
            this.geocodeAddress();
        });
    }

    private readData() {
        const latEl: HTMLElement = document.querySelector("[hotel-map-lat]") as HTMLElement;
        const lngEl: HTMLElement = document.querySelector("[hotel-map-lng]") as HTMLElement;
        const addressEl: HTMLElement = document.querySelector("[hotel-map-address]") as HTMLElement;
        const regionEl: HTMLElement = document.querySelector("[hotel-map-region]") as HTMLElement;
        const nameEl: HTMLElement = document.querySelector("[hotel-map-name]") as HTMLElement;

        this.address = addressEl.getAttribute("hotel-map-address");
        this.geometry.lat = parseFloat(latEl.getAttribute("hotel-map-lat"));
        this.geometry.lng = parseFloat(lngEl.getAttribute("hotel-map-lng"));
        this.name = nameEl.getAttribute("hotel-map-name");
        this.region = regionEl.getAttribute("hotel-map-region");
    }

    private geocodeAddress() {
        const geocoder: google.maps.Geocoder = new google.maps.Geocoder();

        geocoder.geocode({
            address: this.address,
            region: this.region,
        }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                this.geometry.lat = results[0].geometry.location.lat();
                this.geometry.lng = results[0].geometry.location.lng();
                this.plotMapAndMarker();
            } else {
                geocoder.geocode({
                    location: new google.maps.LatLng(this.geometry.lat, this.geometry.lng),
                }, (deepSearchResults, deepSearchStatus) => {
                    if (deepSearchStatus === google.maps.GeocoderStatus.OK) {
                        this.geometry.lat = deepSearchResults[0].geometry.location.lat();
                        this.geometry.lng = deepSearchResults[0].geometry.location.lng();
                        this.plotMapAndMarker();
                    } else {
                        geocoder.geocode({
                            location: new google.maps.LatLng(this.geometry.lng, this.geometry.lat),
                        }, (reverseSearchResults, reverseSearchStatus) => {
                            if (reverseSearchStatus === google.maps.GeocoderStatus.OK) {
                                this.geometry.lat = reverseSearchResults[0].geometry.location.lat();
                                this.geometry.lng = reverseSearchResults[0].geometry.location.lng();
                                this.plotMapAndMarker();
                            } else {
                                this.hideMap();
                            }
                        });
                    }
                });
            }
        });
    }

    private plotMapAndMarker() {
        try {
            let mapObj: google.maps.Map = null;
            let marker: google.maps.Marker = null;

            mapObj = new google.maps.Map(document.getElementById("map"), {
                center: this.geometry,
                zoom: 10,
            });

            marker = new google.maps.Marker({
                position: this.geometry,
                map: mapObj,
                title: this.name,
            });
        } catch (e) { 
            /* tslint:disable */
            console.log(e);
            /* tslint:enable */
            this.hideMap();
        }
    }

    private hideMap() {
        const map: HTMLElement = document.querySelector("#map") as HTMLElement;
        const heading: HTMLElement = document.querySelector(".more-hotels__heading") as HTMLElement;

        map.style.display = "none";
        heading.style.marginTop = "0px";
    }
}



// WEBPACK FOOTER //
// ./src/hotels/HotelMap.ts